function parseYmdPrefix(dateString: string): [number, number, number] | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (Number.isNaN(y) || Number.isNaN(mo) || Number.isNaN(d)) return null;
  return [y, mo, d];
}

/**
 * Formats a blog post date for display in the current UI language.
 * Date-only strings (YYYY-MM-DD) use the local calendar day so they are not
 * shifted by UTC parsing.
 */
export function formatBlogPostDate(dateString: string, lang: string): string {
  const ymd = parseYmdPrefix(dateString);
  if (ymd) {
    const [y, m, day] = ymd;
    const local = new Date(y, m - 1, day);
    return local.toLocaleDateString(lang, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  return new Date(dateString).toLocaleDateString(lang, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function sameCalendarDay(a: string, b: string): boolean {
  const parse = (s: string) => {
    const d = s.split("T")[0];
    const [y, m, day] = d.split("-").map(Number);
    return { y, m, day };
  };
  const A = parse(a);
  const B = parse(b);
  return A.y === B.y && A.m === B.m && A.day === B.day;
}

/** Show a separate “updated” line only when modified date differs from published. */
export function shouldShowBlogUpdatedLine(
  datePublished: string,
  dateModified?: string,
): boolean {
  if (dateModified === undefined) return false;
  return !sameCalendarDay(datePublished, dateModified);
}
